import MetaTags from "../../components/MetaTags";
import UserStatsPage from "../../features/web/userProfile/userStats/UserStatsPage";

function UserStats() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | إحصائياتي"
                description="صفحة إحصائياتي على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض إحصائياتي لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <UserStatsPage />;
        </>
    );
}

export default UserStats;
